import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { LoadingBackdropProps } from "../../types";

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({
  open,
  message = "Loading...",
  showProgress = true,
}) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backdropFilter: "blur(3px)",
      }}
      open={open}
    >
      <Paper
        elevation={4}
        sx={{
          padding: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
        }}
      >
        {showProgress && <CircularProgress color="primary" sx={{ mb: 2 }} />}
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6" component="div" sx={{ mb: 1 }}>
            {message}
          </Typography>
        </Box>
      </Paper>
    </Backdrop>
  );
};

export default LoadingBackdrop;
